import { createContext } from "react";

export const defaultAppContext = {
  height: 0,
  width: 0,
  hideRightNav: false,
  setHideRightNav: () => {},
};

export const AppContext = createContext(defaultAppContext);
